import { render, staticRenderFns } from "./glucoseList.vue?vue&type=template&id=c36603d2&scoped=true"
import script from "./glucoseList.vue?vue&type=script&lang=js"
export * from "./glucoseList.vue?vue&type=script&lang=js"
import style0 from "./glucoseList.vue?vue&type=style&index=0&id=c36603d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36603d2",
  null
  
)

export default component.exports